<div class="tsd_container vessel-form-dialog">
  <mat-card>
    <mat-card-content style="text-align: end;">
      <mat-hint style="color: red;">{{showStatus}} </mat-hint>
      <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked"
      [ngModelOptions]="{standalone: true}" *ngIf="showDeactivateToggle && data.id">Deactivate Vessel</mat-slide-toggle>
      <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked"
      [ngModelOptions]="{standalone: true}"*ngIf="showReactivateToggle && data.id">Reactivate Vessel</mat-slide-toggle>
    </mat-card-content>
    <form [formGroup]="vesselForm" (keydown.enter)="$event.preventDefault()"  (keydown.shift.enter)="$event.preventDefault()">
        <mat-card-content>
          <h4>Add Vessel</h4>
          <mat-form-field class="mat-width">
            <mat-label>Vessel Name</mat-label>
            <input matInput formControlName="name" autocomplete="off">
            <mat-error *ngIf="name.touched && name.invalid && name.hasError('required')">Vessel Name is required</mat-error>
          </mat-form-field>
          <mat-form-field class="mat-width">
            <mat-label>Vessel Operator</mat-label>
              <mat-select formControlName="operatorId" #operatorSelect
                [matTooltip]="operatorSelect.triggerValue" matTooltipPosition="above">
                <mat-option>
                  <ngx-mat-select-search  [searching]="searching"
                      noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Vessel" [formControl]="vesselSearchCtrl">
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="null">None</mat-option>
                <mat-option [disabled]="vOperator.status=='DEACTIVATED'" *ngFor="let vOperator of filteredVesselOperator | async" [value]="vOperator.id">
                  {{vOperator.name}}
                </mat-option>
              </mat-select>
          </mat-form-field>
          <mat-card-actions>
            <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
            <button mat-button color="primary" (click)="onSave()" [disabled]="status.value=='DEACTIVATED' || (!editPermission && id?.value) || (!addPermission && !id?.value)">SAVE</button>
          </mat-card-actions>
        </mat-card-content>
    </form>
  </mat-card>
</div>